module.exports = __webpack_public_path__ + "img/stack04.a92d3235.svg";